import { render, staticRenderFns } from "./FacebookPageInstagramPostCard.vue?vue&type=template&id=8990b9ac"
import script from "./FacebookPageInstagramPostCard.vue?vue&type=script&lang=js"
export * from "./FacebookPageInstagramPostCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports